<script setup lang="ts">
definePageMeta({
  custom_meta_data: {
    topic: 'integrasi',
    message: 'Saya tertarik dengan integrasi API KiriminAja'
  }
})

useDefaultMeta({
  title: 'Integrasi API Ekspedisi untuk Bisnis | KiriminAja',
  description:
    'Tingkatkan efisiensi operasional dengan Integrasi API KiriminAja. Satu API untuk semua ekspedisi: otomatisasi ongkir, resi, dan pengiriman Anda.',
  robots: 'index, follow',
  schema: {
    type: ['SoftwareApplication', 'WebApplication'],
    title: 'Integrasi API'
  }
})

const faqs = [
  {
    question: 'Apa itu integrasi API KiriminAja?',
    answer:
      'Integrasi API KiriminAja menghubungkan sistem bisnis Anda ke jaringan ekspedisi di Indonesia. Satu API untuk semua fungsi pengiriman—dari <i>API ongkir, API cek resi,</i> hingga <i>order & tracking API</i>.'
  },
  {
    question: 'Apa keunggulan utama integrasi API KiriminAja?',
    answer:
      'Anda tidak perlu integrasi ke tiap ekspedisi secara terpisah. Cukup satu koneksi API untuk semua kurir, dengan performa stabil dan uptime 99,95%.'
  },
  {
    question: 'Apa saja fitur utama integrasi API KiriminAja?',
    answer: `<ul class="list-disc list-inside">
        <li><b>Rates API</b> untuk <i>cek ongkir API</i>.</li>
        <li><b>Order API</b> untuk generate resi & request pickup.</li>
        <li><b>Tracking API</b> untuk <i>cek resi API</i> secara real-time.</li>
        <li><b>Webhook API</b> untuk update otomatis ke sistem Anda.</li>
      </ul>`
  },
  {
    question: 'Berapa biaya integrasinya?',
    answer:
      'Tidak ada biaya bulanan. KiriminAja menerapkan <b>commitment fee Rp2.000.000</b> sebagai deposit saldo pengiriman yang bisa digunakan setelah sistem aktif.'
  },
  {
    question: 'Apakah tersedia plugin tanpa coding?',
    answer:
      'Ya. KiriminAja menyediakan <b>plugin WooCommerce & Shopify</b> untuk integrasi instan tanpa pengembangan tambahan.'
  },
  {
    question: 'Apakah integrasi ini cocok untuk bisnis skala besar?',
    answer:
      'Sangat cocok. KiriminAja mendukung API dengan kapasitas tinggi, SLA enterprise, dan dukungan teknis prioritas bagi brand dan korporasi.'
  }
]

const highlightedItems = [
  {
    title: '99.95% API Uptime',
    icon: 'material-symbols:trending-up'
  },
  {
    title: '50+ Juta Webhook & Tracking per bulan',
    icon: 'material-symbols:track-changes'
  },
  {
    title: '18+ Kurir Terintegrasi',
    icon: 'material-symbols:local-shipping-outline'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Integrasi API Pengiriman untuk Brand & Perusahaan"
      sub-title="Integrasi API Kurir & Ekspedisi"
      description="Automasi proses logistik end-to-end dengan satu API terintegrasi. Dari generate resi, cetak label, hingga real-time tracking pelanggan—semua bisa Anda kelola langsung dari sistem internal bisnis Anda."
      hero-image="/images/integration-api-banner-1.webp"
    >
      <template #action>
        <div class="flex items-center gap-2 lg:gap-4 py-2">
          <UiButton
            :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
            label="Dapatkan Demo"
          />
          <UiButton
            :to="$utm.utmUrl('https://developer.kiriminaja.com')"
            label="Lihat Dokumentasi API"
            target="_blank"
            variant="primaryOutline"
          />
        </div>
        <div
          class="flex flex-col lg:flex-row lg:items-center gap-4 lg:flex-wrap"
        >
          <UiCardFeature
            v-for="(item, key) in highlightedItems"
            :key="key"
            class="bg-surface-container"
            wrapper-class="bg-surface-container flex-row items-center p-3"
            title-class="text-sm lg:text-sm"
            icon-wrapper-class="bg-background"
            :icon="item.icon"
            icon-size="24px"
            :title="item.title"
          />
        </div>
      </template>
    </HeroBase>

    <OtherIntegrationFeatures parent-page />
    <OtherIntegrationComparision />
    <PresetCourier
      title="Semua Ekspedisi Favoritmu"
      path="/integration"
      with-instant-courier
    />
    <FaqBase :faqs="faqs" />
    <OtherIntegrationCta />
  </div>
</template>
